import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=21d27cb4&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=21d27cb4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d27cb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d27cb4')) {
      api.createRecord('21d27cb4', component.options)
    } else {
      api.reload('21d27cb4', component.options)
    }
    module.hot.accept("./ThankYou.vue?vue&type=template&id=21d27cb4&scoped=true", function () {
      api.rerender('21d27cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/ThankYou.vue"
export default component.exports